import { createAction } from '@reduxjs/toolkit';
import { push, go, replace } from 'connected-react-router';
import { previousRoutePaths } from 'utils/routeFinderUtil';
import { getDeviceContext } from 'utils/deviceContext';
import { open } from 'actionCreators/exit';
import { EXISTING_JOURNEY, NTB_JOURNEY } from 'constants/general';
import {
  INFORM_CHOICE,
  YOUR_LOAN_OPTIONS,
  DIP_GREAT_NEWS,
  DIP_EMPLOYMENT_DETAILS,
  DIP_YOUR_LOAN_OPTIONS,
  DIP_NO_MATCH,
  DIP_DIRECT_DEBIT_INSTRUCTIONS,
  YOUR_LOAN_PURPOSE,
  INCOME_AND_EXPENSES,
  DIP_MARKETING_PREFERENCES,
  DIP_ABOUT_THIS_CHECK,
  DIP_YOUR_MAIN_BANK_ACCOUNT
} from 'constants/paths';
import { disableDipToFullJourney, disablePostDIPReview } from 'actionCreators/config';
import { mapNTBToDIPFields } from 'actionCreators/case';
import { CREDIT_DECISION_ROUTES_MAP } from 'components/screens/AboutThisCheckDIP/constants';
import { hasValidCurrentAccount } from 'utils/accountUtil';

/**
 * ??
 */
export const exit = open;

export const redirectToOriginApplication = createAction('redirect/originApplication');

export const redirectCustomerDetails = createAction(
  'redirect/customerDetails',
  function prepare(reason) {
    return { payload: reason };
  }
);

export const navigateToScreen =
  (
    path,
    options = {
      editablePaths: []
    },
    replaceScreen = false
  ) =>
  (dispatch, getState) => {
    const locationParams = {
      previous: getState().router.location.pathname,
      ...options
    };
    dispatch(replaceScreen ? replace(path, locationParams) : push(path, locationParams));
  };

export const navigateToDIP =
  (
    path,
    options = {
      editablePaths: []
    }
  ) =>
  (dispatch, getState) => {
    const locationParams = {
      previous: getState().router.location.pathname,
      ...options
    };
    dispatch(mapNTBToDIPFields());
    dispatch(push(path, locationParams));
  };

export const navigateToPreviousScreen = () => (dispatch, getState) => {
  dispatch({
    type: 'navigation/navigateToPreviousScreen'
  });
  const {
    router: {
      location: { pathname }
    },
    navigation: { allowBackwardNavigation, locationToRender, isDipToFullEditFlow },
    caseDetails,
    account
  } = getState();

  if (allowBackwardNavigation === true) {
    const pathDetails = previousRoutePaths[pathname];

    if (pathDetails && Object.keys(pathDetails).length > 0) {
      const {
        config: { journey, origin, hasStartAgain, skipDecisionInPrinciple }
      } = getState();
      //customer coming from brochureware and previous state showing inform choice and origin is null, redirect to BW.
      if (journey === EXISTING_JOURNEY) {
        let isRedirect = false;
        if (locationToRender && locationToRender.state) {
          const { previous } = locationToRender.state;
          if (previous === INFORM_CHOICE && !origin) {
            isRedirect = true;
          }
        } else if (hasStartAgain && pathname === YOUR_LOAN_OPTIONS && !origin) {
          isRedirect = true;
        }

        if (isRedirect) {
          dispatch(redirectToOriginApplication());
          return;
        }
      }

      const previousPath = pathDetails[journey];

      if (journey === NTB_JOURNEY && pathname === DIP_MARKETING_PREFERENCES) {
        dispatch(
          navigateToScreen(
            CREDIT_DECISION_ROUTES_MAP[
              caseDetails?.dipCaseInfo?.submitDipCaseResponse?.creditDecision
            ],
            {
              previous: DIP_ABOUT_THIS_CHECK
            }
          )
        );
        return;
      }

      if (previousPath) {
        if (previousPath === DIP_GREAT_NEWS || previousPath === DIP_NO_MATCH) {
          dispatch(disableDipToFullJourney());
          dispatch(disableCancelFlowFromLoanScreen());
          dispatch(enableBackFlowFromContactDetails());
          dispatch(navigateToScreen(DIP_GREAT_NEWS));
        } else if (previousPath === DIP_YOUR_MAIN_BANK_ACCOUNT) {
          dispatch(
            navigateToScreen(
              hasValidCurrentAccount(account?.accountList)
                ? DIP_GREAT_NEWS
                : DIP_YOUR_MAIN_BANK_ACCOUNT
            )
          );
        } else if (previousPath === DIP_EMPLOYMENT_DETAILS && isDipToFullEditFlow) {
          dispatch(disableDIPToFullEditFlow());
          dispatch(enableBackFlowFromFinalReview());
          dispatch(navigateToScreen(DIP_DIRECT_DEBIT_INSTRUCTIONS));
        } else if (previousPath === YOUR_LOAN_PURPOSE && !skipDecisionInPrinciple) {
          dispatch(navigateToScreen(DIP_YOUR_LOAN_OPTIONS));
        } else {
          if (previousPath === YOUR_LOAN_OPTIONS) {
            dispatch(enableBackFlowFromMarketingPreferences());
            dispatch(disablePostDIPReview());
            dispatch(disableEditFlow());
            dispatch(navigateToScreen(YOUR_LOAN_OPTIONS));
          } else if (journey === NTB_JOURNEY && previousPath === INCOME_AND_EXPENSES) {
            dispatch(navigateToScreen(INCOME_AND_EXPENSES));
          } else if (journey === NTB_JOURNEY && pathname === DIP_GREAT_NEWS) {
            dispatch(navigateToScreen(DIP_ABOUT_THIS_CHECK));
          } else {
            previousPath === INFORM_CHOICE && !skipDecisionInPrinciple
              ? dispatch(redirectToOriginApplication())
              : dispatch(skipDecisionInPrinciple ? go(-1) : navigateToScreen(previousPath));
          }
        }
      } else {
        dispatch(redirectToOriginApplication());
      }
    } else {
      dispatch(redirectToOriginApplication());
    }
  }
};

/**
 * @todo make a util
 * @param {Object} params
 */
export function buildParams(params) {
  return Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
}

export const navigateToLoginRegistration = (loanType) => (dispatch, getState) => {
  dispatch({ type: 'navigation/navigateLoginRegistration', payload: loanType });

  const {
    config: { userTrackingId, configUrls, brandId, sourceId, jointLinkCode, bankId }
  } = getState();

  const source_id = getDeviceContext().isNative ? 'APP' : sourceId;

  window.location = `${configUrls.authenticationUrl}/${brandId}/identity?${buildParams({
    method: 'personal-details',
    response_type: 'token',
    user_tracking_id: userTrackingId,
    client_id: 'vmpl_web',
    redirect_uri: encodeURIComponent(
      `${window.location.origin}?${buildParams({
        loanType,
        ...(source_id && { source_id }),
        ...(jointLinkCode && { jointLinkCode, jointBankId: bankId }),
        skip_dip_process: false
      })}`
    ),
    cancel_uri: window.location.origin
  })}`;
};

export const setOriginPath = createAction('navigation/setOriginPath', function prepare(path) {
  return {
    payload: path
  };
});

export const lockBackwardNavigation = createAction('navigation/lockBackward');

export const unlockBackwardNavigation = createAction('navigation/unlockBackward');

/**
 * Notify the developer that a navigation attempt was blocked due to either forward or backward navigation being locked in state.
 */
export const navigationBlocked = createAction('navigation/blocked');

export const enableEditFlow = createAction('navigation/enableEditFlow');

export const disableEditFlow = createAction('navigation/disableEditFlow');

export const enableDIPToFullEditFlow = createAction('navigation/enableDIPToFullEditFlow');

export const disableDIPToFullEditFlow = createAction('navigation/disableDIPToFullEditFlow');

export const enableBackFlowFromFinalReview = createAction(
  'navigation/enableBackFlowFromFinalReview'
);

export const disableBackFlowFromFinalReview = createAction(
  'navigation/disableBackFlowFromFinalReview'
);

export const enableCancelFlowFromLoanScreen = createAction(
  'navigation/enableCancelFlowFromLoanScreen'
);

export const disableCancelFlowFromLoanScreen = createAction(
  'navigation/disableCancelFlowFromLoanScreen'
);

export const enableBackFlowFromContactDetails = createAction(
  'navigation/enableBackFlowFromContactDetails'
);

export const disableBackFlowFromContactDetails = createAction(
  'navigation/disableBackFlowFromContactDetails'
);

export const enableBackFlowFromMarketingPreferences = createAction(
  'navigation/enableBackFlowFromMarketingPreferences'
);

export const disableBackFlowFromMarketingPreferences = createAction(
  'navigation/disableBackFlowFromMarketingPreferences'
);

export const enableResumeBackFlowFromAboutThisCheck = createAction(
  'navigation/enableResumeBackFlowFromAboutThisCheck'
);

export const disableResumeBackFlowFromAboutThisCheck = createAction(
  'navigation/disableResumeBackFlowFromAboutThisCheck'
);
